<h1 mat-dialog-title i18n="Select lang dialog|title @@selectLangDialog.title">Изменить язык</h1>
<div mat-dialog-content>
  <mat-nav-list>
    <a [class.selected]="isSelected(link)" mat-list-item href="/{{link}}" *ngFor="let link of links" > {{ names[link] }} </a>
  </mat-nav-list>
</div>
